import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { transformDate, TransformDateFormat } from '../helpers/dateHelper'
import colors from '../lib/colors'

const Styles = styled.span`
  display: flex;
  flex-wrap: wrap;
  .formatted-date {
    margin-right: 5px;
  }
  .formatted-time {
    color: ${colors.darkerGray};
  }
`

interface IFormattedDateTimeProps {
  timestamp: number
}

export default function FormattedDateTime(props: IFormattedDateTimeProps): ReactElement {
  const { timestamp } = props

  return (
    <Styles>
      <div className="formatted-date">
        {transformDate(timestamp, TransformDateFormat.NumbersAndSlashes)}
      </div>
      <div className="formatted-time">
        {transformDate(timestamp, TransformDateFormat.OnlyTime)}
      </div>
    </Styles>
  )
}
